import { facadeV4 } from 'src/services';
import { ResponseV4Search } from 'src/types/backendContent';

type FetchElasticSearchProps = {
  body: unknown;
  signal: RequestInit['signal'];
};

export const fetchElasticSearch = async ({
  body,
  signal,
}: FetchElasticSearchProps) => {
  return facadeV4.post<ResponseV4Search>({
    url: 'search',
    signal,
    body,
  });
};
